import { injectable } from 'inversify';
import type { IDispatcherCache } from '../DI/interfaces';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import JsonRpcDispatcher from '@dealroadshow/json-rpc-dispatcher';

@injectable()
class DispatcherCache implements IDispatcherCache {
  private dispatchers = new Map<DataroomTenant, JsonRpcDispatcher>();

  public has(tenant: DataroomTenant): boolean {
    return this.dispatchers.has(tenant);
  }

  public get(tenant: DataroomTenant): JsonRpcDispatcher | undefined {
    return this.dispatchers.get(tenant);
  }

  public set(tenant: DataroomTenant, dispatcher: JsonRpcDispatcher): void {
    this.dispatchers.set(tenant, dispatcher);
  }
}

export default DispatcherCache;
